import { render } from "./RoomDetails.vue?vue&type=template&id=d87c7a1c&ts=true"
import script from "./RoomDetails.vue?vue&type=script&lang=ts"
export * from "./RoomDetails.vue?vue&type=script&lang=ts"

import "./RoomDetails.vue?vue&type=style&index=0&id=d87c7a1c&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__